import { useContext, useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Table, Badge } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { toast } from 'react-toastify';
import { Context as AuthContext } from '../../../../../contexts/AuthContext';
import AnnualReviewService from '../../../../../services/AnnualReview';
import { AnnualReviewResponse } from '../../../AnnualReview/types';

const FinishedAnnualReviewsHistoryCard = () => {
  const { token, currentSchool }: any = useContext(AuthContext);
  const history = useHistory();
  const [reviews, setReviews] = useState<AnnualReviewResponse[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await AnnualReviewService(token).listFinishedForMe(currentSchool?.value);
        setReviews(res?.data || []);
      } catch (e: any) {
        toast.error(e?.response?.data?.message || 'Could not load annual review history');
      } finally {
        setLoading(false);
      }
    };
    if (token) load();
  }, [token]);

  if (loading) return null;
  if (!reviews.length) return null;

  return (
    <Card className="shadow mt-4">
      <CardHeader className="border-0">
        <h3 className="mb-0">
          <i className="fas fa-clipboard-check mr-2" /> Annual Reviews History
        </h3>
        <small className="text-muted">Completed annual reviews across your school(s).</small>
      </CardHeader>
      <CardBody className="p-0">
        <Table responsive striped className="m-0">
          <thead className="thead-light">
            <tr>
              <th>Name</th>
              <th>Start Date</th>
              <th>Cycle</th>
              <th>Signed On</th>
              <th>Signed PDF</th>
            </tr>
          </thead>
          <tbody>
            {reviews.map((r) => (
              <tr key={r.id} style={{ cursor: 'pointer' }} onClick={() => history.push(`/users/${r.userId}/profile`)}>
                <td>{r.employeeName || '-'}</td>
                <td>{r.employeeStartDate ? moment.utc(r.employeeStartDate).format('MM/DD/YYYY') : '-'}</td>
                <td>{r.cycleYear}</td>
                <td>{r.finalSignedAt ? moment.utc(r.finalSignedAt).format('MM/DD/YYYY') : '-'}</td>
                <td>
                  {r.finalSignedPdfUrl ? (
                    <a href={r.finalSignedPdfUrl} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}>
                      <Badge color="info" pill>
                        <i className="fas fa-file-pdf mr-1" /> Download
                      </Badge>
                    </a>
                  ) : (
                    <span className="text-muted">-</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
};

export default FinishedAnnualReviewsHistoryCard;
